// extracted by mini-css-extract-plugin
module.exports = {"label":"BarTooltip_label__3CJlt","value":"BarTooltip_value__3Ugsc","wrapper":"BarTooltip_wrapper__LbuyS"};